export default __webpack_public_path__ + "static/media/timezone-notification-icon.a58804d3.svg";